import $ from 'jquery'

import { SfTime } from '@app/adapters/time'

const KEY_RETURN = 13

const processDate = (datepicker, event) => {
  const format =
    datepicker.data().momentJsFormat ||
    datepicker.data().dateFormat.toUpperCase()
  const date = event.target.value

  if (!date || !date.trim()) return

  const finalDate = SfTime(date, format)

  if (!finalDate.isValid()) return
  if (finalDate.format(format) === date) return

  event.target.value = finalDate.format(format)
}

onDomLoad(function () {
  $(document).on('click focus', '[data-behaviour~="datepicker"]', (event) => {
    const autoclose = event.target.dataset.datepickerAutoclose || false
    const dp = $(event.target)
      .datepicker({
        autoclose: autoclose,
        orientation: 'bottom left',
        zIndexOffset: 99983,
      })
      .datepicker('show')

    $(event.target).on('change', (event) => {
      processDate(dp, event)
    })

    $(event.target).on('keydown', (event) => {
      if (event.which !== KEY_RETURN) return

      processDate(dp, event)
    })
  })
})
